import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
//MUI
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
//ICONOS
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopIcon from '@mui/icons-material/Stop';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

//DS
import useInterval from '../../../hooks/useInterval';
import {validacion} from 'lib.common';
const {esFuncion} = validacion;

function timeFormatter(tiemInMs) {
   const seconds = ('0' + (Math.floor(tiemInMs / 1000) % 60)).slice(-2);
   const minutes = ('0' + (Math.floor(tiemInMs / 60000) % 60)).slice(-2);
   const hours = ('0' + Math.floor(tiemInMs / 3600000)).slice(-2);
   return `${hours}:${minutes}:${seconds}`;
}
/**
 * Componente para medir tiempo en segundos.
 */
function Cronometro(props) {
   //Propiedades
   const {iconSize, setTiempo, setHoraIni} = props;
   //Estados de cotnrol
   const [delay, setDelay] = useState(null);
   const [isRunning, setIsRunning] = useState(false);
   const [time, setTime] = useState(0);
   const [offset, setOffset] = useState(0);
   const [timeS, setTimeS] = useState('');

   useEffect(() => {
      setTimeS(timeFormatter(time));
   }, [time]);

   async function update() {
      const newTime = time + (await delta());
      setTime(newTime);
      if (esFuncion(setTiempo)) {
         setTiempo(newTime);
      }
   }

   function delta() {
      const now = Date.now();
      const timePassed = now - offset;
      setOffset(now);
      return timePassed;
   }

   useInterval(update, delay);

   function start() {
      if (!isRunning) {
         setHoraIni(new Date());
         setOffset(Date.now());
         setIsRunning(true);
         setDelay(1000);
      }
   }

   function stop() {
      if (isRunning) {
         setDelay(null);
         setIsRunning(false);
      }
   }

   function reset() {
      setTime(0);
   }

   return (
      <Box alignItems="center">
         <Typography variant="button">{timeS}</Typography>
         {isRunning === false && time === 0 && (
            <IconButton size={iconSize} aria-label="iniciar" onClick={start}>
               <PlayCircleOutlineIcon />
            </IconButton>
         )}
         {isRunning === true && (
            <IconButton size={iconSize} aria-label="detener" onClick={stop}>
               <StopIcon />
            </IconButton>
         )}
         {isRunning === false && time > 0 && (
            <IconButton size={iconSize} aria-label="reanudar" onClick={start}>
               <PlayArrowIcon />
            </IconButton>
         )}
         {isRunning === false && time > 0 && (
            <IconButton size={iconSize} aria-label="reiniciar" onClick={reset}>
               <AutorenewIcon />
            </IconButton>
         )}
      </Box>
   );
}

Cronometro.propTypes = {
   /**
    * Tamaño de los iconos de inicio, detener y reiniciar.
    */
   iconSize: PropTypes.oneOf(['small', 'medium']),
   /**
    * Funcion a realizar cuando se detiene el cronometro con la siguiente firma:
    *
    * - *tiempoTranscurrido*: int
    */
   setTiempo: PropTypes.func,
   /**
    * Funcion a realizar cuand se inicia el cronometro con la siguiente firma:
    *
    * - *fechaDeInicio*: Date
    */
   setHoraIni: PropTypes.func
};
Cronometro.defaultProps = {
   iconSize: 'small',
   setHoraIni: (fechaHoraInicial) => {}
};
export default Cronometro;
